import { useState } from 'react';
import { Bug, Bookmark, Flag, CheckSquare } from 'lucide-react';

interface TaskTypeIconProps {
  url?: string | null;
  name?: string;
  className?: string;
}

const getFallbackIcon = (name: string) => {
  if (name.includes('bug')) return { Icon: Bug, color: 'text-red-500' };
  if (name.includes('story')) return { Icon: Bookmark, color: 'text-green-600' };
  if (name.includes('epic')) return { Icon: Flag, color: 'text-purple-600' };
  return { Icon: CheckSquare, color: 'text-blue-600' };
};

export const TaskTypeIcon = ({ url, name = 'task', className = '' }: TaskTypeIconProps) => {
  const [broken, setBroken] = useState(false);
  const normalized = name?.toLowerCase() || 'task';

  if (!url || broken) {
    const { Icon, color } = getFallbackIcon(normalized);
    return <Icon className={`${className} ${color}`} />;
  }

  return (
    <img
      src={url || undefined}
      alt={name}
      className={className}
      onError={() => setBroken(true)}
    />
  );
};

export default TaskTypeIcon;

